


























































































enum PageSizeTypes {
  A6 = "A6",
  A5 = "A5",
  A4 = "A4",
  A3 = "A3",
  A2 = "A2",
  A1 = "A1",
  A0 = "A0",
  CUSTOM = "Custom",
}

import { Component, Vue } from "vue-property-decorator";
@Component
export default class ShowManagerCatalogPanel extends Vue {
  metric: boolean = true;

  pageSize: { type: PageSizeTypes; width: number; height: number } = {
    type: PageSizeTypes.A4,
    width: 10,
    height: 10,
  };
  selectedPageSizeType: PageSizeTypes = PageSizeTypes.A4;
  pageSizeTypes: Array<PageSizeTypes> = Object.values(PageSizeTypes);
  //pageSizes : Array<{type : PageSizeTypes, width : number, height : number} >
  showPageNumber: boolean = false;

  get units(): string {
    return this.metric ? "mm" : "in";
  }

  get customPageSizeType(): boolean {
    return this.selectedPageSizeType === PageSizeTypes.CUSTOM;
  }

  metricToImperial(x: number): number {
    return x / 25.4;
  }
  imperialToMetric(x: number): number {
    return x * 25.4;
  }
}
